export default __webpack_public_path__ + "static/media/glade-legacy.ccf10ef1.png";